import { FilterFields } from '../components/ManagedDataTable/interfaces';
import {
  FilterEntry,
  FilterValue,
  IPaginatedResourceEndpointParams,
} from './interfaces';

export const getPaginatedEndpointParams = ({
  page,
  perPage,
  sort,
  search,
  filters,
}: IPaginatedResourceEndpointParams): Record<
  string,
  string | number | boolean
> => {
  const params: Record<string, string | number | boolean> = {
    page,
    perPage,
  };

  if (sort) {
    params.sort = `${sort.field};${sort.sort}`;
  }

  if (search) {
    params.search = search;
  }

  if (filters) {
    params.filters = getFiltersEndpointParams(filters);
  }

  return params;
};

export const getFiltersEndpointParams = (filters: FilterFields): string => {
  const filterObject: Record<
    string,
    FilterEntry | FilterEntry[] | FilterValue[]
  > = {};

  filters.forEach((filter) => {
    if ('values' in filter) {
      filterObject[filter.field] = filter.values;
    } else {
      if (!filterObject[filter.field]) {
        filterObject[filter.field] = {
          operator: filter.operator,
          value: filter.value,
        };
      } else {
        let entry = filterObject[filter.field];

        if (!Array.isArray(entry)) {
          filterObject[filter.field] = [entry];
        }

        (filterObject[filter.field] as FilterEntry[]).push({
          operator: filter.operator,
          value: filter.value,
        });
      }
    }
  });

  return encodeURIComponent(JSON.stringify(filterObject));
};
